import React from "react";

const brandStyles = {

    linkHover: '#68A637', 
    deepBlue: "#394C92", 
};


export default function WhyOrgavitaz() {
  
  // Inline styles for brand colors
  const styles = {
    linkHover: {
      color: brandStyles.linkHover,
    },
    deepBlue: {
      color: brandStyles.deepBlue,
    },
  };

  return (
    // Section acts as a full-width container for the content
   <section className="py-5 bg-white" id="overview">
      <div className="container text-start bg-white">
        {/* Small heading */}
        <h2 className="fw-bold text-center mb-3" style={{ color: brandStyles.linkHover }}>
          Why Orgavitaz ?
        </h2>
        {/* First paragraph */}
        <p className="lead text-muted mb-4 fs-6">
         Research shows fruits and vegetables intake is directly linked to health and longevity. Fruits and veggies are vital sources of vitamins, minerals and antioxidants, but industrial agriculture is clearly not giving enough of them. So, we need to identify supplements for your diet with right ingredients from specialized agroecological models that sustain nutrition . 
        </p>
        {/* Second paragraph */}
        <p className="lead text-muted fs-6">
          But how healthy are most multivitamins? It is estimated that over 95% of all vitamin supplements contain synthetics and isolates.<span className="fw-bold" style={{ color: brandStyles.deepBlue }}> From placebo effect to physiological benefits….. </span>
        </p>
        <p className="lead text-muted fs-6">
          Your body is not a test chamber to take some synthetic material and rapidly excrete it unmetabolized in urine, temporarily staying in the plasma. 
        </p>
        <h2 className="text-center" style={{ color: brandStyles.deepBlue }}>
          If your vitamins absolutely matter, Orgavitaz matters…
        </h2>
        <p className="lead text-muted fs-6">
          Good vitamins produce metabolic results proportionate to its metabolic clearance rate. They are POTENT. Potency is not just the dosage, it is the ability of the vitamer to create a natural affinity with the body for physiological benefits. 
        </p>
      </div>
    </section>
  );
}